import {useQuery} from "@tanstack/react-query";
import {IEvent} from "../declarations";
import {createApiClient} from "../utilities/apiClient";

const getSailInfoTimeline=async (guid: string): Promise<IEvent[]> => {
    const axiosSailTag=createApiClient();
    const response=await axiosSailTag.get<IEvent[]>(`/api/SailInfo/GetSailInfoTimeline/${encodeURIComponent(guid)}`);
    return response.data;
};

export const useGetSailInfoTimeline=(guid: string) =>
    useQuery<IEvent[]>({
        queryKey: [
            "GetSailInfoTimeline",
            {
                guid: guid??null
            }
        ],
        queryFn: () => {
            if(!guid?.trim()) {
                throw new Error("Invalid params for GetSailInfoTimeline");
            }
            return getSailInfoTimeline(guid);
        },
        enabled: Boolean(guid?.trim()),
        refetchOnWindowFocus: true,
        retry: false,
        placeholderData: []
    });